<template>
  <div id="page">

    <Erro500 :erro="noTenant" v-if="noTenant"/>

    <div v-if="!noTenant && !$route.meta.disablePageHeader && !loadingContent && $root.$session.usuario.logged && $root.$session.usuario.logged.point">
      <EmpresaHeader/>
    </div>
    
    <div id="content" class="pl-3 pr-3 pb-3" v-if="!noTenant && !loadingContent">
        <div class="row ">
          <div class="col-md-12" v-if="!$route.meta.disablePageHeader">
            <h3>{{$route.meta.title.toUpperCase()}}</h3>
            <b-breadcrumb :items="this.$root.$session.navigation"></b-breadcrumb>
          </div>

          <div class="col-md-12">
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
          </div>
        </div>
    </div>

    <div id="footer" v-if="!noTenant && !loadingContent && $root.$session.cliente.logged">
      <EmpresaFooter/>
    </div>

  </div>
</template>

<script>
import EmpresaHeader from "common/menu/header.v2";
import EmpresaFooter from "common/menu/footer.v2";
import Erro500 from 'apps/template/500'

export default {
  name: "app",
  components: { EmpresaHeader, EmpresaFooter,Erro500},
  mixins: [],
  data() {
    return {
      loadingContent: true,
      noTenant:null
    };
  },

  beforeRouteUpdate(to, from, next) {
    this.validarLogin(to, from, next);
  },

  mounted() {
    this.getTenant();
  },

  created() {
    this.$root.$session.sub_domain = "empresa";
    this.$root.$loading.set(true,'Carregando')
    this.validarLogin();
	  this.$root.$session.tenant = this.$route.params.tenant;
  },

  methods: {

    getTenant() {

      this.noTenant = null;

      this.$root.$request.get("config").then(result => {


        if(result.status == 200 && result.data){
          this.$root.$session.cliente = result.data;
          
          this.getUsuario();
        }
        else{
          this.noTenant = result.msg;
        }
      });
    },

     getEmpresa() {

      this.$root.$request.get("meu-cadastro").then(result => {
        
        if(result.status == 200) {
          this.$root.$session.empresa = result.data;
        } 

        this.loadingContent = false;
        this.$root.$loading.set(false)
      
      });
    },

    getUsuario() {

      this.$root.$request.get('usuario/menu').then(result => {
        
        if(result.status == 200 && result.data){
          this.$root.$session.usuario = result.data.usuario;
          this.$root.$session.jwt = this.$root.$session.logged();
          this.validarSenha();
        }

        this.getEmpresa()
      });
    },

    validarSenha(){

      // if(this.$root.$session.usuario && this.$root.$session.usuario.logged && this.$root.$session.usuario.logged.id_usu != 1 && this.$root.$session.usuario.logged.fl_pass == 1){
      //   this.$root.$dialog.confirm('Sua senha possui mais de 6 meses. Deseja alterar sua senha agora?')
      //   .then(() => {
      //     this.$router.push({name:'empresa.cadastro'});
      //   });
      // }
    },

    validarLogin(to,from,next){
      
      if(!to)to = this.$route;

      $('body').removeClass('bg-login');
      if(to.name == 'empresa.login')
        $('body').addClass('bg-login');

      //VALIDAR AUTH
      if(to.meta && to.meta.title && to.meta.navigation){
        this.$root.$session.navigation = to.meta.navigation;
        this.$root.$session.setTitle(to.meta.title);
      }

      if(!to.matched.some(record => record.meta.requiresAuth)) {
        if(next)
          next();
      }
      else{
        if(!this.$root.$session.logged()){
          this.$router.push({name:'empresa.login'});
        }
        else{
          if(next)
            next();
        }
      }
    },

  }
};
</script>
<style lang="scss" scoped>
@import "~assets/styles/empresa.scss";
</style>


// WEBPACK FOOTER //
// empresa.vue?640b87b1